import { Component } from '@angular/core';

import { ButtonColor } from '@shared/ui/button/button.component';

@Component({
  selector: 'app-navigation-secondary-finances',
  template: `
    <app-bar flTrackingSection="SubnavFinances">
      <app-bar-item
        link="/users/financial-dash"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="Finances"
      >
        Finances
      </app-bar-item>
      <app-bar-item
        link="/payments/transactions.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="TransactionHistory"
      >
        Transaction History
      </app-bar-item>
      <app-bar-item
        link="/payments/verify.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="VerifyPaymentMethod"
      >
        Verify Payment Method
      </app-bar-item>
      <app-bar-item
        link="/deposit"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="DepositFunds"
      >
        Deposit Funds
      </app-bar-item>
      <app-bar-item
        link="/payments/withdraw.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="WithdrawMoney"
      >
        Withdraw Money
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation finances bar post project button"
        flTrackingLabel="PostProjectButton">
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryFinancesComponent {
  ButtonColor = ButtonColor;
}



// WEBPACK FOOTER //
// ./src/app/navigation-secondary/navigation-secondary-finances.component.ts